<div class="flex min-h-0 grow flex-col bg-transparent">
  @if (showHeader()) {
    <div class="flex items-center gap-3 border-b border-gray-100 px-4 py-4">
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
        <mat-icon svgIcon="messages-outline" class="h-5! w-5!" />
      </div>
      <div class="min-w-0">
        <p class="text-sm font-semibold text-gray-900">Chat with provider</p>
        <p class="truncate text-xs text-gray-500">
          Check your last chats with your doctor
        </p>
      </div>
    </div>
  }

  <!-- Message thread -->
  <div
    #thread
    (scroll)="onScroll()"
    class="relative flex min-h-0 grow flex-col gap-4 overflow-y-auto px-4 py-4">
    @if (loading()) {
      <div class="flex grow items-center justify-center">
        <icaredx-spinner />
      </div>
    } @else if (threadItems().length === 0) {
      <div
        class="flex grow flex-col items-center justify-center gap-1 text-center text-sm"
        [class]="emptyBodyClass()">
        <span class="font-medium" [class]="emptyTitleClass()">
          No messages yet
        </span>
        <span>Send a message to start the conversation</span>
      </div>
    } @else {
      @for (item of threadItems(); track item.id) {
        @if (item.type === 'date') {
          <div class="flex items-center justify-center py-1">
            <span class="text-xs font-medium" [class]="separatorClass()">
              {{ item.label }}
            </span>
          </div>
        } @else {
          @let message = item.message;
          <div
            class="flex items-start gap-2.5"
            [class.flex-row-reverse]="isOwn(message)">
            <icaredx-display-avatar
              size="small"
              [profileImageUrl]="avatarUrl(message)"
              [givenName]="avatarName(message).givenName"
              [familyName]="avatarName(message).familyName" />
            <div
              class="flex min-w-0 flex-1 flex-col gap-1"
              [class.items-end]="isOwn(message)">
              <div class="flex items-center gap-1.5 text-xs">
                @if (isOwn(message)) {
                  <span [class]="timeClass()">
                    {{ message.sentAt | date: 'shortTime' }}
                  </span>
                  <span class="font-semibold" [class]="nameClass()">
                    {{ senderName(message) }}
                  </span>
                } @else {
                  <span class="font-semibold" [class]="nameClass()">
                    {{ senderName(message) }}
                  </span>
                  <span [class]="timeClass()">
                    {{ message.sentAt | date: 'shortTime' }}
                  </span>
                }
              </div>
              @if (message.document) {
                <icaredx-chat-document-bubble
                  class="max-w-[80%]"
                  [document]="message.document" />
              } @else {
                <div [class]="bubbleClasses(message)">{{ message.text }}</div>
              }
              @if (message.failed) {
                <button
                  type="button"
                  class="flex items-center gap-1.5 text-xs text-red-400 transition-colors hover:text-red-300"
                  (click)="retry(message)">
                  <mat-icon
                    svgIcon="alert-circle-outline"
                    class="h-4! w-4! shrink-0" />
                  Message not sent. Tap to retry.
                </button>
              }
            </div>
          </div>
        }
      }
    }
  </div>

  <!-- Composer -->
  <div class="flex items-center gap-3 border-t px-3 py-3" [class]="composerBorderClass()">
    <textarea
      #composer
      rows="1"
      placeholder="Write a reply ..."
      class="max-h-32 min-h-11 flex-1 resize-none rounded-lg border-none px-4 py-2.5 text-sm leading-relaxed focus:outline-none focus:ring-0"
      [class]="textareaClass()"
      [value]="draft()"
      [disabled]="!canSend()"
      (input)="onInput($event)"
      (keydown)="onKeydown($event)"></textarea>
    <icaredx-mic-button (transcribed)="onTranscribed($event)" />
    <button
      type="button"
      aria-label="Send message"
      class="flex h-8.5 w-8.5 shrink-0 items-center justify-center rounded-full bg-primary-600 transition-colors enabled:hover:bg-primary-700 disabled:opacity-40"
      [disabled]="!draft().trim() || sending() || !canSend()"
      (click)="send()">
      <mat-icon svgIcon="paper-plane-outline" class="h-3.5! w-3.5! text-white!" />
    </button>
  </div>
</div>
